/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet, View, Dimensions } from 'react-native';
import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import SociollaText from '@components/sociolla/SociollaText';
// import HTMLView from 'react-native-htmlview';
import RenderHtml from 'react-native-render-html';
import PropTypes from 'prop-types';

const propTypes = {
  withoutBorder: PropTypes.bool,
  between: PropTypes.bool,
  centered: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  nameBold: PropTypes.bool,
  nameStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  nameComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  name: PropTypes.string,
  valueComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  valueBold: PropTypes.bool,
  valueStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  html: PropTypes.bool,
  onPress: PropTypes.func,
};

const defaultProps = {
  withoutBorder: false,
  between: false,
  centered: false,
  style: {},
  nameBold: false,
  nameStyle: {},
  nameComponent: '',
  name: '',
  valueComponent: '',
  value: '',
  valueBold: false,
  valueStyle: {},
  html: false,
  onPress: () => {},
};

const fullWidth = Dimensions.get('screen').width;
const fontSizeRight = !isNative ? 12 : 13;

const ItemDetail = (props) => {
  const {
    testID,
    withoutBorder = false,
    between = false,
    centered = false,
    style = {},
    nameBold = false,
    nameStyle = {},
    nameComponent = '',
    name = '',
    valueComponent = '',
    value = '',
    valueBold = false,
    valueStyle = {},
    html = false,
    onPress = () => {},
  } = props;
  return (
    <View
      testID={testID}
      style={[
        styles.item,
        {
          borderBottomColor: withoutBorder ? Colors.white : Colors.grey0,
          justifyContent: between ? 'space-between' : 'flex-start',
          alignItems: centered ? 'center' : 'flex-start',
        },
        style,
      ]}>
      {nameComponent ? (
        <View style={[styles.itemLeft, nameStyle]}>{nameComponent}</View>
      ) : (
        <SociollaText
          type={nameBold ? 'medium' : 'regular'}
          style={[styles.itemLeft, nameStyle]}>
          {name}
        </SociollaText>
      )}
      {valueComponent ? (
        valueComponent
      ) : value ? (
        Array.isArray(value) ? (
          <View style={styles.itemRight}>
            {(value || []).map((item, idx) => (
              <View
                style={[
                  { width: !isNative ? '100%' : fullWidth - 160 },
                  idx != (value || []).length - 1
                    ? styles.itemArray
                    : {}.length,
                  {
                    marginBottom: idx != (value || []).length - 1 ? 15 : 0,
                  },
                ]}
                key={idx}>
                <SociollaText
                  type={valueBold ? 'medium' : 'regular'}
                  style={[styles.itemSubRight, valueStyle]}>
                  {item || '-'}
                </SociollaText>
              </View>
            ))}
          </View>
        ) : html ? (
          <RenderHtml
            source={{
              html: value,
            }}
            defaultViewProps={{
              style: styles.html,
            }}
            defaultTextProps={{ style: styles.htmlText }}
            contentWidth={isWeb ? 190 : fullWidth - 160}
          />
        ) : (
          <SociollaText
            type={valueBold ? 'medium' : 'regular'}
            onPress={onPress}
            style={[styles.itemRight, valueStyle]}>
            {value}
          </SociollaText>
        )
      ) : (
        <SociollaText style={[styles.itemRight, valueStyle]}>
          {'-'}
        </SociollaText>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  item: {
    width: '100%',
    flexDirection: 'row',
    paddingVertical: 15,
    borderBottomWidth: 1,
  },
  itemLeft: {
    width: isWeb ? 170 : 120,
    fontSize: 12,
    color: Colors.grey1,
  },
  itemRight: {
    width: !isNative ? 'calc(100% - 130px)' : fullWidth - 160,
    fontSize: fontSizeRight,
    marginLeft: 20,
  },
  itemSubRight: {
    width: '100%',
    fontSize: fontSizeRight,
  },
  html: { width: isWeb ? 170 : fullWidth - 160, marginTop: 0 },
  htmlText: { fontSize: fontSizeRight },
  itemArray: {
    paddingBottom: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

ItemDetail.propTypes = propTypes;
ItemDetail.defaultProps = defaultProps;

export default ItemDetail;
